var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-select', {
    class: `form-qualification-experience-${_vm.className}`,
    attrs: {
      "items": _vm.workExperiences,
      "menuProps": {
        attach: `.form-qualification-experience-${_vm.className}`
      },
      "disabled": _vm.form.workExperience.isIrrelevant,
      "multiple": "",
      "outlined": "",
      "attach": ""
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.workExperience.items,
      callback: function ($$v) {
        _vm.$set(_vm.form.workExperience, "items", $$v);
      },
      expression: "form.workExperience.items"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-currency-field', {
    staticClass: "text-right",
    attrs: {
      "disabled": _vm.form.workExperience.isIrrelevant,
      "outlined": "",
      "suffix": "년 "
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.workExperience.years,
      callback: function ($$v) {
        _vm.$set(_vm.form.workExperience, "years", $$v);
      },
      expression: "form.workExperience.years"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-currency-field', {
    staticClass: "text-right",
    attrs: {
      "disabled": _vm.form.workExperience.isIrrelevant,
      "outlined": "",
      "suffix": "개월",
      "max": 11
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.workExperience.months,
      callback: function ($$v) {
        _vm.$set(_vm.form.workExperience, "months", $$v);
      },
      expression: "form.workExperience.months"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_vm._v(" 이상 ")])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "경력무관",
      "dense": "",
      "inset": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.onChangeIsIrrelevant
    },
    model: {
      value: _vm.form.workExperience.isIrrelevant,
      callback: function ($$v) {
        _vm.$set(_vm.form.workExperience, "isIrrelevant", $$v);
      },
      expression: "form.workExperience.isIrrelevant"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }